import React, { useState } from 'react'
import {
  CardContainer,
  Description,
  Title,
  VisibilityContainer,
  VisibilityOffContainer,
  WrapperTitle,
  WrapperValue,
  Text,
} from './styles'
import Icon from '../icon'

export interface Props {
  'data-qa'?: string
  description?: string
  title: string
  icon?: string
  svg?: object
  showIconVisibility?: boolean
  showValueDefault?: boolean
  children?: any
  onChange?: Function
}

const Card: React.FC<Props> = (props: Props) => {
  const [showValue, setShowValue] = useState<boolean>(props.showValueDefault)
  const dataQa = props['data-qa']

  function renderContent(): JSX.Element {
    return (
      <Text data-qa={`${dataQa}-text`}>
        {props.children ?? props.description}
      </Text>
    )
  }

  function renderValue() {
    return showValue ? renderContent() : <VisibilityOffContainer />
  }

  return (
    <CardContainer>
      <WrapperTitle>
        {props.icon && <Icon name={props.icon} size={24} />}
        {props.svg && <Icon svg={props.svg} size={24} />}
        <Title>{props.title}</Title>
      </WrapperTitle>

      <WrapperValue>
        <Description>{renderValue()}</Description>
        {props.showIconVisibility && (
          <VisibilityContainer>
            <Icon
              name={showValue ? 'visibility_off' : 'visibility'}
              onClick={() => {
                setShowValue(!showValue)
                props.onChange()
              }}
            />
          </VisibilityContainer>
        )}
      </WrapperValue>
    </CardContainer>
  )
}

export default Card

Card.defaultProps = {
  showValueDefault: true,
  showIconVisibility: false,
}
